import * as React from "react";
import s from "./operacao.scss";
import { MultiPlaceRetrospectiveData, RetrospectiveData } from "../../api/types";
import { AnimatedNumber } from "../../utils/use-count-up";
import Icon from "#components/icon";
import { operacaoContent } from "./content";
import { PlaceCarousel } from "../place-carousel";
import { formatNumberConditional } from "../../utils/format-number";

interface OperacaoProps {
	operatingTime: RetrospectiveData["operatingTime"];
	multiPlaceData?: MultiPlaceRetrospectiveData;
	selectedPlaceIndex?: number;
	onPlaceIndexChange?: (index: number) => void;
}

export function Operacao({
	operatingTime,
	multiPlaceData,
	selectedPlaceIndex = 0,
	onPlaceIndexChange,
}: OperacaoProps) {
	const currentOperatingTime = React.useMemo(() => {
		if (!multiPlaceData) return operatingTime;

		const places = multiPlaceData.places;

		// Verificação de segurança: índice válido
		if (selectedPlaceIndex < 0 || selectedPlaceIndex >= places.length) {
			console.warn(
				`Operacao: selectedPlaceIndex ${selectedPlaceIndex} está fora do range (0-${
					places.length - 1
				})`,
			);
			return operatingTime;
		}

		const currentPlace = places[selectedPlaceIndex];

		// Verificação de segurança: place existe
		if (!currentPlace) {
			console.warn(
				`Operacao: currentPlace não encontrado no índice ${selectedPlaceIndex}`,
			);
			return operatingTime;
		}

		console.log(
			"Operacao - currentPlace:",
			currentPlace.id,
			"selectedPlaceIndex:",
			selectedPlaceIndex,
		);

		if (currentPlace.id === "aggregated") {
			return multiPlaceData.aggregated.operatingTime;
		}

		const placeOperatingTime = multiPlaceData.byPlace[currentPlace.id]?.operatingTime;

		if (!placeOperatingTime) {
			console.warn(
				`Operacao: dados não encontrados para place ${currentPlace.id}`,
				multiPlaceData.byPlace,
			);
		}

		return placeOperatingTime || operatingTime;
	}, [multiPlaceData, selectedPlaceIndex, operatingTime]);

	return (
		<section id="operacao" className={s.operacao}>
			<div className={s.sectionContainer}>
				<h2 className={s.sectionTitle}>{operacaoContent.title}</h2>

				{multiPlaceData && onPlaceIndexChange && (
					<PlaceCarousel
						places={multiPlaceData.places}
						currentIndex={selectedPlaceIndex}
						onChangeIndex={onPlaceIndexChange}
					/>
				)}

				<div className={s.operacaoGrid}>
					<div className={`${s.operacaoCard} ${s.cardTeal}`}>
						<div className={s.operacaoIcon}>
							<Icon icon="ri-calendar-line" />
						</div>
						<h3>
							<AnimatedNumber
								value={currentOperatingTime.daysOfOperation}
								duration={1200}
								prefix="+"
							/>
						</h3>
						<p>{operacaoContent.daysOfOperation}</p>
					</div>
					<div className={`${s.operacaoCard} ${s.cardOrange}`}>
						<div className={s.operacaoIcon}>
							<Icon icon="ri-hourglass-line" />
						</div>
						<h3>
							<AnimatedNumber
								value={currentOperatingTime.hoursWorked}
								duration={1200}
								prefix="+"
								formatNumber={formatNumberConditional}
							/>
						</h3>
						<p>{operacaoContent.hoursWorked}</p>
					</div>
					<div className={`${s.operacaoCard} ${s.cardPurple}`}>
						<div className={s.operacaoIcon}>
							<Icon icon="ri-time-line" />
						</div>
						<h3>
							<AnimatedNumber
								value={currentOperatingTime.minutesInYear}
								duration={1200}
								prefix="+"
								formatNumber={formatNumberConditional}
							/>
						</h3>
						<p>{operacaoContent.minutesInYear}</p>
					</div>
				</div>
			</div>
		</section>
	);
}
